<template>
	<div>
		<NavigationMenuLink v-for="(navOption, index) in navOptions" :key="index">
			<component
				:is="navOption.route ? NuxtLink : 'div'"
				:to="navOption.route"
				class="flex size-full cursor-pointer select-none flex-col justify-end rounded-md p-4 no-underline outline-none transition-all hover:bg-primary-light-4 focus:shadow-md"
				@click="handleClick(navOption)"
			>
				<PortalHeaderNavOption
					:variant="navOption.description ? 'description' : 'default'"
				>
					<template #icon>
						<component
							:is="navOption.icon?.component"
							v-if="navOption.icon"
							v-bind="navOption.icon.bindings"
						/>
					</template>
					<template #title>
						<span class="flex items-center gap-2">
							{{ navOption.label }}
							<Badge
								v-if="navOption.badge"
								variant="secondary"
								class="h-auto w-10 shrink-0 rounded-[2px] border-primary-light-4 bg-primary-light-4 px-1.5 py-0.5 font-Inter font-medium text-[10px] leading-[150%]"
							>
								{{ navOption.badge }}
							</Badge>
						</span>
					</template>
					<template #description>
						{{ navOption.description }}
					</template>
				</PortalHeaderNavOption>
			</component>
		</NavigationMenuLink>
	</div>
</template>
<script setup lang="ts">
import { NuxtLink } from '#components';
import { handleEventProps } from '~/composables/events/headerEvents';
import { useEvents } from '~/composables/events/useEvents';

import { Badge } from '~/components/ui/badge';

import { type NavDefaultOptionConfig } from '.';

const { trackHeader } = useEvents();

type Props = {
	navOptions: NavDefaultOptionConfig[];
};

defineProps<Props>();

const handleClick = (navOption: NavDefaultOptionConfig) => {
	handleEventProps(
		navOption.eventProps,
		trackHeader.handleEventMenuHeaderClick
	);
	navOption.eventCallback?.();
};
</script>
